import React, { useState } from "react";
import { Button, RHFTextField, Section, Link } from "@arp/react-ndbx";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import useTheme from "@mui/material/styles/useTheme";
import Typography from "@mui/material/Typography";
import { URLS, sendEmailModalContent } from "../../../config/const/enums";
import { yourDetailsContactFieldNames } from "../../../config/pageInfo/pageFieldName";

import EmailSentSuccess from "./EmailSentSuccess";

//** Data Hooks */
import { useGetQuote } from "../../../hooks/dataHooks/useGetQuoteData";
import { useEmailQuoteMutation } from "../../../hooks/dataHooks/useEmailQuoteMutation.js";

//** Hooks */
import { getModalDefaultStyle } from "../../../utilities/getFontValues";
import usePreQualification from "../../../hooks/usePreQualification";
import useSharedData from "../../../hooks/useSharedData";

//----------------------------------------------------------------

export default function SendEmailModal({
  openSendEmailModal,
  handleSendEmailClose,
  handleSuccessEmailModal,
  sendQuoteEmailSuccess,
  sendEmailImg,
  person = "personOne",
  quoteStageNew,
}) {
  const theme = useTheme();
  const { dataSet } = usePreQualification();
  const { data: quoteData, isLoading: quoteIsLoading } = useGetQuote();
  const [sendingEmailLoading, setSendingEmailLoading] = useState(false);
  const { accessToken } = useSharedData();

  const style = getModalDefaultStyle(theme);
  const emailQuoteMutation = useEmailQuoteMutation();

  const sendQuote = async () => {
    setSendingEmailLoading(true);

    const emailQuoteResponse = await emailQuoteMutation.mutateAsync({
      accessToken,
      quoteStageNew,
    });

    if (emailQuoteResponse?.status === 200) {
      handleSuccessEmailModal();
    }
    setSendingEmailLoading(false);
  };

  return (
    <Modal open={openSendEmailModal} onClose={handleSendEmailClose}>
      <Box sx={style} data-identifier="save-send-email-modal">
        <Section
          sx={{
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
            mt: 0,
            mb: 0,
            mr: { xs: 1, sm: 3 },
            position: "sticky",
            // position: "-webkit-sticky",
            top: { xs: 16, sm: 24 },
          }}
        >
          <CloseIcon
            onClick={handleSendEmailClose}
            justify="center"
            alignItems="center"
            sx={{ cursor: "pointer" }}
          ></CloseIcon>
        </Section>
        {!sendQuoteEmailSuccess && (
          <Section
            sx={{
              pl: { xs: 4, sm: 8 },
              pr: { xs: 4, sm: 8 },
              pt: { xs: 5 },
              mt: 0,
              mb: 0,
            }}
          >
            <Section sx={{ mt: 0, mb: 3 }}>
              <Typography variant="h3-bold">
                {sendEmailModalContent.SEND_QUOTE_TO_EMAIL}
              </Typography>
            </Section>
            <Section sx={{ maxWidth: { xs: 258 }, mb: 4 }}>
              <Section sx={{ mt: 5, mb: { xs: 3, sm: 4 } }}>
                <Section sx={{ mb: 0 }}>
                  <img width="100%" src={sendEmailImg}></img>
                </Section>
              </Section>
              <Section md={12} mt={{ sm: 2, md: 4 }}>
                <RHFTextField
                  className="subvariant-text-input"
                  variant="standard"
                  label="Email address"
                  name={yourDetailsContactFieldNames(person).EMAIL_ADDRESS}
                  defaultValue={dataSet[person].emailAddress}
                  type="email"
                  disabled
                />
              </Section>
              <Section md={12} mt={{ sm: 2, md: 4 }}>
                <RHFTextField
                  className="subvariant-text-input"
                  variant="standard"
                  label="Mobile number"
                  name={yourDetailsContactFieldNames(person).CONTACT_NUMBER}
                  defaultValue={dataSet[person].contactNumber}
                  type="phone"
                  disabled
                />
              </Section>
            </Section>

            <Section sx={{ mb: 3, mt: 0 }}>
              <Typography
                id="modal-modal-description"
                variant="p3"
                sx={{ mt: 2 }}
              >
                {sendEmailModalContent.EMAIL_MOBILE_NOTE}
              </Typography>
            </Section>
            <Section mb={3}>
              <Section sx={{ maxWidth: { xs: "185px" } }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={sendQuote}
                  disabled={sendingEmailLoading}
                >
                  SEND QUOTE
                </Button>
              </Section>
            </Section>
            <Section sx={{ mt: 0, mb: 3 }}>
              <Typography variant="p2-bold">
                {sendEmailModalContent.APPLICATION_SAVED_SUCCESSFULLY}
                <b>{quoteData?.quoteInformation?.quoteNumber}</b>.
              </Typography>
            </Section>
            {/* <Section sx={{ mt: 0, mb: 2 }}>
              <Typography variant="p2">
                {sendEmailModalContent.APPLICATION_REFERENCE}{" "}
                <b>{quoteData?.quoteInformation?.quoteNumber}</b>
              </Typography>
            </Section> */}
            {/* <Section sx={{ mt: 0, mb: 2 }}>
              <Typography variant="p2-bold">
                {sendEmailModalContent.APPLICATION_ACCESS}
              </Typography>
            </Section> */}
            <Section sx={{ mb: 2, mt: 0 }}>
              <Typography variant="p3">
                {sendEmailModalContent.APPLICATION_RETRIEVE}
              </Typography>
            </Section>
            <Section sx={{ mb: 2, mt: 0 }}>
              <Typography variant="p3">
                <Link
                  href={URLS.YOUR_DUTY_EXCLUSION_PRIVACY_NOTICE_URL}
                  target="_blank"
                >
                  Your duty
                </Link>
                {sendEmailModalContent.DUTY_NOTE}
              </Typography>
            </Section>
            <Section sx={{ mb: 2, mt: 0 }}>
              <Typography variant="p3">
                {sendEmailModalContent.QUERY_CONTACT_US}{" "}
                <Link href={URLS.CONTACT_US_PHONE_URL}>
                  {URLS.CONTACT_US_PHONE_NUMBER}
                </Link>
                .
              </Typography>
            </Section>
            {/* <Section sx={{ mb: 0, mt: 0 }}>
              <Typography variant="p3">
                {sendEmailModalContent.REACCESSING_APPLICATION_NOTE}
              </Typography>
            </Section> */}
          </Section>
        )}
        {sendQuoteEmailSuccess && (
          <EmailSentSuccess
            customerEmailAddress={dataSet[person].emailAddress}
          />
        )}
      </Box>
    </Modal>
  );
}
